import React from 'react';
import PropTypes from 'prop-types';

import CardSegment from './card';
import TextSegment from './text';
import ImageSegment from './image';

import './segment.css';

const segmentComponents = {
  card: CardSegment,
  text: TextSegment,
  image: ImageSegment,
};

const Segment = ({ segment }) => {
  const type = segment.get('type');
  if (typeof segmentComponents[type] !== 'undefined') {
    const SegmentComponent = segmentComponents[type];
    return <SegmentComponent segment={segment} />;
  }
  return <div>Unknown segment type: {type}</div>;
};

Segment.propTypes = {
  segment: PropTypes.object.isRequired,
};

export default Segment;



// WEBPACK FOOTER //
// ./src/components/blocks/double/segment/index.js